import React from "react";
import ReactMarkdown from "react-markdown";

import { a } from "@react-spring/web";
import { useAnimateInTrail } from "hooks/useAnimateInTrail";
import { initialOffset } from "components/Animations/SpringProperties/SpringProperties";

import classNames from "classnames";
import * as fromProjects from "store/Projects";

interface IOwnSpecificProps {
  animateIn: boolean;
  titleContent: object;
}

type IOwnProps = IOwnSpecificProps;

type IProps = IOwnProps;

export const InlineTitle: React.FC<IProps> = ({ animateIn, ...props }) => {
  const titleContent: fromProjects.IContentTitleThreeColumnSection =
    props.titleContent as fromProjects.IContentTitleThreeColumnSection;
  const [animateInTrail] = useAnimateInTrail(animateIn, 2);

  const titleStyles = {
    opacity: animateInTrail[0].active,
    transform: animateInTrail[0].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  const descriptionStyles = {
    opacity: animateInTrail[1].active,
    transform: animateInTrail[1].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  return (
    <div
      className={classNames(
        "titleWrapper",
        "threeColumn",
        "inlineTitle",
        { mediumTopPadding: titleContent.topPadding === "medium" },
        { largeTopPadding: titleContent.topPadding === "large" }
      )}
    >
      <a.h1 style={titleStyles}>
        <strong>{titleContent.title}</strong>
        {titleContent.subtitle}
      </a.h1>
      <a.div className="description" style={descriptionStyles}>
        <ReactMarkdown source={titleContent.description} />
      </a.div>
    </div>
  );
};
